import { Player } from '../types';

/**
 * Formats a player's name for display.
 * For players where name is "Eemil Erholtz" or "Aaron Erholtz", shows only the name field.
 * For all other players, shows "firstName name" if firstName exists, otherwise just "name".
 */
export const formatPlayerName = (player: Player): string => {
  // Special case for Erholtz players - show only the name field
  if (player.name === 'Eemil Erholtz' || player.name === 'Aaron Erholtz') {
    return player.name;
  }
  
  // Default behavior for all other players
  return player.firstName ? `${player.firstName} ${player.name}` : player.name;
};
